import axios from "axios";
import geolib from "geolib";
import moment from "moment";
import _ from "lodash";
import { push } from "redux-little-router";
import { onSaveClusters, onChangeMap, onReCenterMap } from "./map";
import { onShowDetail } from "./ui";
import get from "lodash/get";
import { shouldShowLocation, transformLocation } from "../../utils/locations";

export const prepareData = (locations) => {
  return {
    type: "PREPARE_DATA",
    locations: locations
  };
};

export function onPrepareData(input, fetchGoogleImage = false) {
  return (dispatch, getState) => {
    const { mapOptions } = getState().brc;
    var data = [];
    if (input.hasOwnProperty("_id")) data.push(input);
    else data = input;

    var locations = data.filter(shouldShowLocation).map((location)=>transformLocation(location, fetchGoogleImage));
    if (input.hasOwnProperty("_id")) {
      let url =
      "/" +
      mapOptions.center.lat +
      "/" +
      mapOptions.center.lng +
      "/" +
      mapOptions.zoom +
      "/" +
      `${locations[0].id}`;
      dispatch(push(url));
      dispatch(setDetail(locations[0]));
      dispatch(onShowDetail(true));
    } else {
      dispatch(prepareData(locations));
      dispatch(onSaveClusters());
    }
  };
}

export function fetchLocations() {
  return (dispatch, getState) => {
    axios("/locations/")
      .then(function (response) {
        return response.data;
      })
      .then(function (locations) {
        dispatch(onPrepareData(locations));
      })
      .catch(function (err) {
        console.warn(err);
      });
  };
}

export const fetchGrades = (grades) => {
  return {
    type: "FETCH_GRADES",
    grades: grades
  };
};
export function onFetchGrades(id) {
  return (dispatch, getState) => {
    var dates = [];
    axios("/grades/" + id)
      .then(function (response) {
        return response.data;
      })
      .then(function (data) {
        var records = [];
        data.hits.hits.forEach((record) => {
          var date = moment(record._source.GradeDate).format("MM-DD-YYYY");
          if (dates.indexOf(date) == -1 && record._source.DryGrade !== "ns") {
            dates.push(date);
            record._source.GradeDate = date;
            records.push(record._source);
          }
        });
        return records;
      })
      .then(function (grades) {
        grades.sort((a, b) => {
          a = new Date(a.GradeDate);
          b = new Date(b.GradeDate);
          return a - b;
        });
        // console.log(grades);
        return grades;
      })
      .then(function (g) {
        // console.log(g);
        dispatch(fetchGrades(g));
      })
      .catch(function (err) {
        console.warn(err);
      });
  };
}

export const fetchNews = (news) => {
  return {
    type: "FETCH_NEWS",
    news: news
  };
};
export function onFetchNews() {
  return (dispatch, getState) => {
    axios("/news/")
      .then(function (response) {
        return response.data;
      })
      .then(function (news) {
        var n = news.map((newsItem) => {
          return newsItem._source;
        });
        dispatch(fetchNews(n));
      })
      .catch(function (err) {
        console.warn(err);
      });
  };
}

export const fetchAds = (ads) => {
  return {
    type: "FETCH_ADS",
    ads: ads
  };
};
export function onFetchAds() {
  return (dispatch, getState) => {
    axios("/banner/")
      .then(function (response) {
        // console.log(response);
        return response.data;
      })
      .then(function (json) {
        var ad = {};
        if (!_.isEmpty(json.ad)) {
          ad = {
            ...json.ad._source,
            id: json.ad._id,
            showId: json.showId
          };
        }
        dispatch(fetchAds(ad));
      })
      .catch(function (err) {
        console.warn(err);
      });
  };
}

export const setResults = (results) => {
  return {
    type: "SET_RESULTS",
    results: results
  };
};
export function onSetResults(newSort) {
  return (dispatch, getState) => {
    const { clusters, selectedItem, activeTab, mapOptions, sort } =
      getState().brc;
    var results = [],
      selectedResult = {};
    clusters.forEach((cluster) => {
      cluster.points.forEach((item) => {
        if (selectedItem && item.id === selectedItem.id) selectedResult = item;
        results.push(item);
      });
    });

    if (results.length > 0) {
      var centerCoords = {
        latitude: mapOptions.center.lat,
        longitude: mapOptions.center.lng
      };
      var findCenter = geolib.findNearest(centerCoords, results, 0);
      var centerItem = results[parseInt(findCenter.key)];
    }
    var timeframe = moment().subtract(8, "days");
    var timeframe2 = moment().subtract(1, "days");

    var filtered = results.filter((result) => {
      switch (activeTab) {
        case 0:
          return true;
        case 1:
          if (
            result.hasOwnProperty("nowcast_pass_flag") &&
            moment(result.nowcast_date)
              .add(7, "hours")
              .isSameOrAfter(timeframe2)
          ) {
            return true;
          }
          return false;
        case 2:
          if (
            result.dry_grade &&
            result.dry_grade !== "ns" &&
            moment(result.grade_updated).isSameOrAfter(timeframe)
          ) {
            return true;
          } else if (
            result.wet_grade &&
            result.wet_grade !== "ns" &&
            moment(result.grade_updated).isSameOrAfter(timeframe)
          ) {
            return true;
          }
          return false;
        case 3:
          if (result.currentAlerts.length > 0) {
            return true;
          }
          return false;
        default:
          return false;
      }
    });
    // console.log(filtered);
    var s = newSort ? newSort : sort;
    var sortOrder = [
      "nsBest",
      "alert",
      "good",
      "A+",
      "A",
      "A-",
      "B+",
      "B",
      "B-",
      "C+",
      "C",
      "C-",
      "poor",
      "D+",
      "D",
      "D-",
      "F+",
      "F",
      "F-",
      "nsWorst"
    ];
    filtered.forEach((item) => {
      var g;
      if (item.currentAlerts.length > 0) {
        g = 1;
      } else if (
        item.hasOwnProperty("nowcast_pass_flag") &&
        moment(item.nowcast_date).add(7, "hours").isSameOrAfter(timeframe2)
      ) {
        g =
          parseInt(item.nowcast_pass_flag) > 0
            ? sortOrder.indexOf("good")
            : sortOrder.indexOf("poor");
      } else if (
        item.dry_grade &&
        item.dry_grade !== "ns" &&
        item.dry_grade !== "undefined" &&
        moment(item.grade_updated).isSameOrAfter(timeframe)
      ) {
        g = sortOrder.indexOf(item.dry_grade);
      } else if (
        item.wet_grade &&
        item.wet_grade !== "ns" &&
        item.wet_grade !== "undefined" &&
        moment(item.grade_updated).isSameOrAfter(timeframe)
      ) {
        g = sortOrder.indexOf(item.wet_grade);
      } else {
        if (newSort)
          g =
            sort === "best"
              ? sortOrder.indexOf("nsBest")
              : sortOrder.indexOf("nsWorst");
        else
          g =
            sort === "best"
              ? sortOrder.indexOf("nsWorst")
              : sortOrder.indexOf("nsBest");
      }
      item.sort = g;
    });
    switch (s) {
      case "default":
        if (selectedResult.hasOwnProperty("latitude")) {
          var targetItem = selectedResult;
        } else if (centerItem) {
          var targetItem = centerItem;
        }
        var sortByDistance = geolib.orderByDistance(targetItem, filtered);
        var sortedList = [];
        sortByDistance.forEach((item2) => {
          sortedList.push(filtered[parseInt(item2.key)]);
        });
        filtered = sortedList;
        break;
      case "best":
        filtered.sort((a, b) => {
          return a.sort - b.sort;
        });
        break;
      case "worst":
        filtered.sort((a, b) => {
          return b.sort - a.sort;
        });
        break;
    }
    dispatch(setResults(filtered));
  };
}

export const addItem = (item) => {
  return {
    type: "ADD_ITEM",
    item: item
  };
};
export function onAddItem(item) {
  return (dispatch, getState) => {
    dispatch(addItem(item));
  };
}

export const removeItem = () => {
  return {
    type: "REMOVE_ITEM",
    item: null
  };
};
export function onRemoveItem() {
  return (dispatch, getState) => {
    dispatch(removeItem());
  };
}

export const setDetail = (item) => {
  return {
    type: "SET_DETAIL",
    item: item
  };
};
export function onSetDetail(item) {
  return (dispatch, getState) => {
    const { mapOptions } = getState().brc;
    const id = typeof item === "string" ? item : `${item.id}`;
      axios("/locations/" + id)
        .then(function (response) {
          return response.data;
        })
        .then(function (location) {
          dispatch(onPrepareData(location, true));
        })
        .catch(function (err) {
          console.warn(err);
        });
  };
}

export const setGooglePlaceItem = (googlePlaceItem) => {
  return {
    type: "SET_GOOGLE_PLACE_ITEM",
    payload: googlePlaceItem
  };
};

const zoomMap = {
  1500: 16,
  5000: 14,
  8000: 13,
  20000: 12,
  40000: 11,
  55000: 10,
  70000: 9,
  90000: 8
};

const getMapCenterAndZoom = (locations, googlePlaceCoords) => {
  const locationCoords = locations.map((loc) => ({
    latitude: get(loc, "latitude", get(loc, "lat", 0)),
    longitude: get(loc, "longitude", get(loc, "lng", 0))
  }));
  const nearestCoords = geolib.findNearest(googlePlaceCoords, locationCoords);
  const nearestBeach = locations.find(
    (loc) =>
      get(loc, "latitude", 0) === nearestCoords.latitude &&
      get(loc, "longitude", 0) === nearestCoords.longitude
  );
  const zoomLevel = get(
    zoomMap,
    Object.keys(zoomMap).find((z) => z > nearestCoords.distance),
    14
  );

  const centerOfPlaceAndNearestBeach = geolib.getCenterOfBounds([
    googlePlaceCoords,
    {
      latitude: get(nearestBeach, "latitude", get(nearestBeach, "lat", 0)),
      longitude: get(nearestBeach, "longitude", get(nearestBeach, "lng", 0))
    }
  ]);

  if (
    nearestCoords.distance > 90000 ||
    centerOfPlaceAndNearestBeach.latitude === 0 ||
    centerOfPlaceAndNearestBeach.longitude === 0
  ) {
    return {
      center: googlePlaceCoords,
      zoom: 14
    };
  }

  return {
    center: centerOfPlaceAndNearestBeach,
    zoom: zoomLevel
  };
};

/**
 * @param {{description: string, lat: number, lng: number}} googlePlaceItem
 */
export function onSetGooglePlaceItem(googlePlaceItem) {
  return (dispatch, getState) => {
    dispatch(setGooglePlaceItem(googlePlaceItem));
    const googlePlaceCoords = {
      latitude: googlePlaceItem.lat,
      longitude: googlePlaceItem.lng
    };

    const locations = getState().brc.locations;
    const { center, zoom } = getMapCenterAndZoom(locations, googlePlaceCoords);

    const { wW, wH } = getState().brc;

    if (wW < 600 && wH > wW) {
      dispatch(onReCenterMap(center.latitude, center.longitude, zoom - 1));
    } else {
      dispatch(
        onChangeMap({
          center: {
            lat: center.latitude,
            lng: center.longitude
          },
          zoom
        })
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/content.js